<form @submit.prevent="queryParams.resetOffset" 
    class="keyword-filter grow lg:grow-0 md:grow-0 md:shrink-0 md:basis-[250px] w-[200px] sm:w-auto lg:basis-[300px] xl:basis-[400px]">
    <label class="sr-only" for="keyword-filter">Search</label>
    <div class="relative">
        <div class="absolute inset-y-0 left-0 flex items-center pl-1 pointer-events-none">
            <svg class="w-1.25 h-1.25 text-primary" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                stroke-width="1.5" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke="currentColor" stroke-linejoin="round"
                    d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
            </svg>
        </div>
        <input type="text" id="keyword-filter" class="!pl-3 block" name="keywords" placeholder="Enter any keywords..."
            v-model.lazy="queryParams.params.keywords" @change="queryParams.resetOffset">
    </div>
</form>
